import React from 'react';
import './Home.css';
import Header from '../../components/Header/Header';
import ProfessorsList from '../../components/ProfessorList/ProfessorList';
import Footer from '../../components/Footer/Footer';

const Home = () => {
    return (
        <div className="page-container">    
            <Header />            
            <main className="main-section">
                <ProfessorsList />
            </main>
            <Footer />
        </div>
    );
};

export default Home;
